__turbopack_context__.v({
  "container": "Video-module__2ZnJnq__container",
  "iframe": "Video-module__2ZnJnq__iframe",
});
